import { useEffect } from "react";

const SITE = "https://www.animalanalytics.co.in";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Injects title, meta tags, canonical and an array of JSON-LD schema objects.
export const Seo = ({ title, description, canonical, jsonLd = [] }) => {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "title", title);
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "twitter:title", title);
    upsertMeta("property", "twitter:description", description);
    if (canonical) {
      upsertLink("canonical", canonical.startsWith("http") ? canonical : SITE + canonical);
      upsertMeta("property", "og:url", canonical.startsWith("http") ? canonical : SITE + canonical);
    }

    const nodes = [];
    jsonLd.forEach((obj, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seo = `dynamic-${i}`;
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      nodes.push(s);
    });
    return () => nodes.forEach((n) => n.remove());
  }, [title, description, canonical, jsonLd]);

  return null;
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url.startsWith("http") ? it.url : SITE + it.url,
  })),
});

export const articleSchema = (b) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: b.h1,
  description: b.metaDescription,
  datePublished: b.date,
  dateModified: b.updated,
  author: { "@type": "Organization", name: "Animal Analytics" },
  publisher: {
    "@type": "Organization",
    name: "Animal Analytics",
    logo: { "@type": "ImageObject", url: SITE + "/logo.png" },
  },
  mainEntityOfPage: `${SITE}/blog/${b.slug}`,
  keywords: b.keywords,
});

export { SITE };
